import React from 'react';
import PropTypes from 'prop-types';

import {
  FieldInput,
  FieldSelect,
  FieldRadio,
  FieldCheckbox,
  FieldDate,
  FieldButton,
  FieldMultiCheckbox,
  FieldPlusMinusInput,
  FieldTextNote,
  FieldMultiLineText,
  FieldRichText,
  FieldMoney
} from './fields';
import { Error } from '../design/elements';
import FieldComplexLeadButton from './fields/fieldComplexLeadButton';
import FieldFile from './fieldFile';
import EditableSalesRepInfo from '../design/shared/form/editableSalesRepInfo';
import FieldMultiFileUpload from './fields/multiFileUpload';

const FormField = ({ data, orderData, error = '' }) => {
  const { type } = data;
  let result;

  switch (type) {
    case 'Address':
    case 'AddressDetails':
    case 'Text':
    case 'Number':
      result = <FieldInput data={data} />;
      break;
    case 'Select':
      result = <FieldSelect data={data} />;
      break;
    case 'Radio':
      result = <FieldRadio data={data} />;
      break;
    case 'File':
      result = <FieldFile data={data} />;
      break;
    case 'Checkbox':
      result = <FieldCheckbox data={data} />;
      break;
    case 'MultiCheckbox':
      result = <FieldMultiCheckbox data={data} />;
      break;
    case 'Date':
      result = <FieldDate data={data} />;
      break;
    case 'Button':
      result = <FieldButton data={data} />;
      break;
    case 'PlusMinusInput':
      result = <FieldPlusMinusInput data={data} />;
      break;
    case 'Money':
      result = <FieldMoney data={data} />;
      break;
    case 'TextNote':
      result = <FieldTextNote data={data} />;
      break;
    case 'MultiLineText':
      result = <FieldMultiLineText data={data} />;
      break;
    case 'ComplexLeadButton':
      result = <FieldComplexLeadButton data={data} />;
      break;
    case 'RichText':
      result = <FieldRichText data={data} />;
      break;
    case 'EditSalesInfo':
      result = <EditableSalesRepInfo />;
      break;
    case 'MultiFileUpload':
      result = <FieldMultiFileUpload data={data} orderData={orderData} />;
      break;

    default:
      result = null;
  }

  return (
    <>
      {result}
      {error && <Error text={error} />}
    </>
  );
};

FormField.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    readonly: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  }).isRequired,
  orderData: PropTypes.shape({}),
  error: PropTypes.string
};

export default FormField;
